
import $ from "jquery"
import "bootstrap-modal"
import "bootstrap-modalmanager"
import Auth_manager from "app/authentication/manager"

const CELL_SELECTOR = ".cell-authentication-modal"

const onLoad = () => {
  Auth_manager.on("sign_in:success:action", () => $(CELL_SELECTOR).modal("hide"))
  Auth_manager.on("sign_up:success:action", () => $(CELL_SELECTOR).modal("hide"))
  Auth_manager.on("forgot_password:success:action", () => $(CELL_SELECTOR).modal("hide"))
}

export default {onLoad}
